// @flow
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from '../../../components/auth/auth.service';
import {Subscription} from 'rxjs';
import Swal from 'sweetalert2';

/* interface User {
    name: string;
    email: string;
    password: string;
} */

@Component({
    selector: 'forgotpassword',
    template: require('./forgotpassword.html'),
})

export class ForgotPasswordComponent implements OnInit {
  /*   user: User = {
        name: '',
        email: '',
        password: ''
    }; */
   // isCollapsed = true;
    /* menu = [{
        title: 'forgotpassword',
        'link': '/forgotpassword',
    }]; */
    errors: {field?: Error} = {};
   //submitted = false;
    AuthService;
    Router;
    isLoggedIn;

    public forgotPassword: any;
    busy: Subscription;

    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        backdrop: `rgba(30, 30, 37, 0.4)`
    });

    static parameters = [AuthService, Router, HttpClient];
    constructor(_AuthService_: AuthService, router: Router, private http: HttpClient) {
        this.AuthService = _AuthService_;
        this.Router = router;
        this.http = http;
      
    }
   /*  
    constructor() {

    } */
        ngOnInit() {
          //   console.log("Wellcome to Forgot Password");
           // this.Router.navigateByUrl('/forgotpassword');
           this.forgotPassword = {};
        }    
        goForforgotPassword({ value, valid }){
          //   console.log("form", valid + 'asdasd:::' + value);
          //   console.log("this.forgotPassword", this.forgotPassword);
            if (valid) {
                this.busy = this.http.post('/api/users/forgotPassword', this.forgotPassword, {observe: 'response'})
                                .subscribe(response => {
                                  //   console.log("response", response);
                                    if (response.status == 200) {
                                        this.toastWarningMsg("Password Reset Successfull");
                                        setTimeout(() => {
                                            this.Router.navigate(['/login']);    
                                        }, 300);                                        
                                    }
                                    else {
                                        this.toastWarningMsg("Error while resetting password");
                                    }
                                })
            }
        }

    toastWarningMsg(msg) {
        this.toast({
            type: 'warning',
            title: msg
        });
    }
}
